import { REGIONEAEREOARRIVO} from './regioneAereoArrivoTypes'

const initialState = {
    regioneAereoArrivo: ""
}

const regioneAereoArrivoReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case REGIONEAEREOARRIVO:
            
            return {
                regioneAereoArrivo: action.load
            }
    
        default:
          return state
    }

}


export default regioneAereoArrivoReducer;